const COLUMN_COUNT = window.WCCP_COMPONENT_COLUMNS || 4;

const CLASSES = {
    step: 'composite_component component paged options-style-thumbnails multistep',
    stepTitleWrap: 'component_title_wrapper',
    stepTitleH2: 'step_title_wrapper component_title',
    stepTitleText: 'component_title_text step_title_text',
    stepTitle: 'step_title',
    inner: 'component_inner',
    selections: 'component_selections',
    sectionTitle: 'component_section_title',
    options: 'component_options',
    optionsInner: 'component_options_inner cp_clearfix',
    ul: `component_option_thumbnails_container cp_clearfix columns-${COLUMN_COUNT}`,
    li: 'component_option_thumbnail_container',
    option: 'cp_clearfix component_option_thumbnail',
    imgWrap: 'image thumbnail_image',
    nameWrap: 'thumbnail_description',
    selected: 'selected'
};


const selFor = (clsStr) => '.' + clsStr.trim().split(/\s+/).join('.');

const qs  = (sel, ctx = document) => (ctx || document).querySelector(sel);
const qsa = (sel, ctx = document) => Array.from((ctx || document).querySelectorAll(sel));

const HIDDEN_SET = new Set(
    (window.WCCP_HIDDEN_COMPONENTS || []).filter(Boolean).map(x => String(x).trim())
);

const isHiddenStep = (stepEl) => {
    const cid = stepEl?.dataset?.item_id;
    // DEV: Ignore hiding
    if (devIgnoreHiding()) {
        window.WCCP_DEV_CONSOLE?.warn("IGNORE_HIDING", stepEl.dataset);
        return false;
    }
    return cid ? HIDDEN_SET.has(String(cid)) : false;
};

async function processHiddenStep(stepEl) {
    if (!stepEl) return;

    // DEV: Disable processing of hidden steps
    if (devIgnoreHiding()) {
        window.WCCP_DEV_CONSOLE?.log("IGNORE_HIDING", "processHiddenStep skipped");
        stepEl.style.display = 'block';
        updateStepNavButtons(stepEl);
        return;
    }

    try {
        if (typeof narrowIfNeededForStep === 'function') {
            await narrowIfNeededForStep(stepEl);
        }
        if (typeof ensureVariationsForStep === 'function') {
            await ensureVariationsForStep(stepEl);
        }

        const compId = Number(stepEl.dataset.item_id);

        const allowedSet = (computeAllowedByComponent().get(compId)) || new Set();

        if (!allowedSet.size) {
            delete STATE.selected[compId];
            delete STATE.selectedVariants[compId];
            stepEl.style.display = 'none';
            return;
        }

        const allowedOpts = qsa(selFor(CLASSES.option), stepEl).filter(opt =>
            allowedSet.has(Number(opt.dataset.productId))
        );


        const pref = window.WCCP_PRESELECT?.[compId];
        let chosenOpt =
            (pref && pref.product_id && allowedOpts.find(o => Number(o.dataset.productId) === Number(pref.product_id))) ||
            allowedOpts.find(o => Number(o.dataset.productId) === Number(STATE.selected[compId])) ||
            allowedOpts[0];

        if (!chosenOpt) {
            delete STATE.selected[compId];
            delete STATE.selectedVariants[compId];
            stepEl.style.display = 'none';
            return;
        }

        const blockSimple = devBlockAutoSelectSimpleForStep(stepEl);

        // qsa(selFor(CLASSES.option), stepEl).forEach(o => o.classList.remove(CLASSES.selected));
        // chosenOpt.classList.add(CLASSES.selected);

        const pid = Number(chosenOpt.dataset.productId);
        // STATE.selected[compId] = pid;
        //  if (!devBlockAutoSelectSimple()) {
         if (!blockSimple) {
            qsa(selFor(CLASSES.option), stepEl)
            .forEach(o => o.classList.remove(CLASSES.selected));

            chosenOpt.classList.add(CLASSES.selected);
            STATE.selected[compId] = pid;
             if (window.ConstructorRenderer) {
                 window.ConstructorRenderer.render();
             }
        } else {
            window.WCCP_DEV_CONSOLE?.warn(
                "AUTOSELECT_BLOCKED",
                { source: "processHiddenStep", compId }
            );
        }

        if (blockSimple) {
            // If you can't autoselect, you can't autohide
            stepEl.style.display = 'block';
            updateStepNavButtons(stepEl);
            disableNextButtonIfNoSelection(stepEl);
            return;
        }

        const { min_qty } = getQtyForComponent(compId, pid);
        STATE.selectedQty[compId] = min_qty;

        // DEV: Log state update
        function getStateSnapshot() {
            return {
                selected: { ...STATE.selected },
                selectedVariants: { ...STATE.selectedVariants },
                selectedQty: { ...STATE.selectedQty }
            };
        }


        if (window.WCCP_DEV_MODE?.debug?.stateInfo) {
            window.WCCP_DEV_CONSOLE?.log("STATE_UPDATE", {
                source: "Hidden_step",
                state: getStateSnapshot(),
                data: {
                    product_id: STATE.data?.product_id,
                    components_count: STATE.data?.components?.length || 0,
                    scenarios_count: STATE.data?.scenarios?.length || 0,
                    component_ids: STATE.data?.components?.map(c => c.id),
                    scenario_ids: STATE.data?.scenarios?.map(s => s.id || s.scenario_id)
                }
            });
        }

        const sel = chosenOpt.querySelector('.wccp-variation-select');
        if (sel) {
            if (pref?.variation_id) {
                const tgt = Array.from(sel.options).find(o => Number(o.value) === Number(pref.variation_id));
                if (tgt) sel.value = tgt.value;
            }
            if (!sel.value) {
                const valid = Array.from(sel.options).filter(o => o.value);
                if (valid.length === 1) sel.value = valid[0].value;
            }
            STATE.selectedVariants[compId] = sel.value ? Number(sel.value) : undefined;
            if (sel.value) sel.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
            delete STATE.selectedVariants[compId];
        }

        stepEl.style.display = 'none';
        sanitizeSelectionsAgainstScenarios();

    } catch (e) {
        console.error('[hidden] process error', e);
    }
}



const stepHasVisibleOptions = (stepEl) => {
    if (!stepEl) return false;
    if (devIgnoreHiding()) return true;

    if (stepEl.classList.contains('accessories-step')) {
        return true;
    }

    const lis = stepEl.querySelectorAll(selFor(CLASSES.li));
    return Array.from(lis).some(li => li.style.display !== 'none');
};


const STATE = { data: null, selected: {}, selectedVariants: {}, selectedQty: {}, selectedAccessories: {}  };
window.STATE = STATE; 
let NARROW_SUSPENDED = false;
const NARROW_INFLIGHT = new Map();
const NARROW_RESULT  = new Map();
const NARROW_DISABLED = false;
window.WCCP_PRESELECT = window.WCCP_PRESELECT || {};


function suspendNarrowing(fn) {
    NARROW_SUSPENDED = true;
    try { return fn(); } finally { NARROW_SUSPENDED = false; }
}

function stepIsEffectivelyVisible(stepEl) {
    if (!stepEl) return false;

    const compId = Number(stepEl.dataset.item_id);

    if (compId === STATE.accessories_step_id) {
        const accGroups = STATE.data?.accessories?.["0"]?.components || [];
        const rules = getActiveAccessoryRules();


        const hasVisibleContent = accGroups.some(group => {
            if (!group.enabled || rules.hiddenGroups.has(group.id)) return false;

            const hiddenInThisGroup = rules.hiddenProducts.get(group.id) || new Set();
            const visibleProductsCount = group.products.filter(p => !hiddenInThisGroup.has(Number(p.id))).length;

            return visibleProductsCount > 0;
        });

        return hasVisibleContent;
    }

    const allowed = computeAllowedByComponent().get(compId) || new Set();

    // if (!allowed.size) return false;
    // DEV: single-option blocked by devBlockAutoSelectSimple
    if (
        allowed.size === 1 &&
        devBlockAutoSelectSimpleForStep(stepEl)
    ) {
        
        markDevAutoSkipped(
            stepEl,
            'single-option'
        );
        window.WCCP_DEV_CONSOLE?.log(
            'AUTO_SKIPPED_BLOCKED_BY_DEV_OPTION',
            {
                component_id: compId,
                step: stepEl.dataset.step,
                reason: 'single-option',
                devFlag: 'blockAutoSelectionSimple'
            }
        );
        // Force step to be treated as visible
        return true;
    }
    if (!allowed.size) {
        
        if (devIgnoreHiding()) {
            stepEl.dataset.devHiddenReason = 'scenario';
            window.WCCP_DEV_CONSOLE?.warn(
                'SCENARIO_HIDDEN_BUT_SHOWN',
                {
                    step: stepEl.dataset.step,
                    component_id: compId,
                    effects: window.WCCP_DEBUG?.scenarioEffectsByComponent?.[compId] || []
                }
            );
            return true; 
        }
        return false;
    }

    const options = qsa(selFor(CLASSES.option), stepEl);
    return options.some(opt => allowed.has(Number(opt.dataset.productId)));
}

function applyPreselectForComponent(stepEl) {
    if (!stepEl) return;
    const compId = Number(stepEl.dataset.item_id);
    const pref = window.WCCP_PRESELECT[compId];
    if (!pref || !pref.product_id) return;

    const opt = stepEl.querySelector(`[data-product-id="${pref.product_id}"]`);
    if (opt) {
        stepEl.querySelectorAll('[data-product-id]').forEach(o => o.classList.remove('selected'));
        // opt.classList.add('selected');
        // if (window.STATE) window.STATE.selected[compId] = Number(pref.product_id);
         if (!devBlockAutoSelectSimpleForStep(stepEl)) {
            opt.classList.add('selected');
            // STATE.selected[compId] = Number(pref.product_id);
            if (window.STATE) window.STATE.selected[compId] = Number(pref.product_id);
        } else {
            markDevAutoSkipped(stepEl, 'single-option');
            window.WCCP_DEV_CONSOLE?.warn(
                "AUTOSELECT_BLOCKED",
                { source: "applyPreselect", compId }
            );
        }
    }

    if (pref.variation_id) {
        const sel = opt && opt.querySelector('.wccp-variation-select');
        if (sel) {
            const target = Array.from(sel.options).find(o => Number(o.value) === Number(pref.variation_id));
            if (target) {
                sel.value = String(pref.variation_id);
                if (window.STATE) window.STATE.selectedVariants[compId] = Number(pref.variation_id);
                sel.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }
}

function stepNeedsNarrowing(stepEl) {
    const comp = getComponentById(Number(stepEl.dataset.item_id));
    if (!comp) return false;
    const prods = Array.isArray(comp.products) ? comp.products : [];
    const hasMany = prods.length > 1;
    const hasVariable = prods.some(p => !!p.is_variable);
    return hasMany || hasVariable;
}

const COMPONENT_ORDER = () => (STATE.data?.components || []).map(c => Number(c.id));

function upstreamComponentIds(targetId) {
    const order = COMPONENT_ORDER();
    const idx = order.indexOf(Number(targetId));
    return idx <= 0 ? [] : order.slice(0, idx);
}

function getQtyForComponent(compId, productId) {
    const scenarios = STATE.data?.scenarios || [];

    for (const sc of scenarios) {
        if (!Array.isArray(sc.available_components)) continue;

        for (const ac of sc.available_components) {
            if (Number(ac.component_id) === Number(compId) &&
                Number(ac.product_id) === Number(productId)) {

                return {
                    min_qty: ac.min_qty ?? 1,
                    max_qty: ac.max_qty ?? ac.min_qty ?? 1
                };
            }
        }
    }

    return { min_qty: 1, max_qty: 1 };
}

function getActiveAccessoryRules() {
    const rules = {
        hiddenGroups: new Set(),
        hiddenProducts: new Map()
    };

    const accRoot = STATE.data?.accessories?.["0"];
    if (!accRoot || !accRoot.scenarios) return rules;

    accRoot.scenarios.forEach(scenario => {
        if (!scenario.enabled) return;

        const isMatch = (scenario.conditions || []).every(cond => {
            const selectedValue = String(STATE.selected[cond.component] || "");

            const condValues = Array.isArray(cond.value) ? cond.value.map(String) : [String(cond.value)];

            switch (cond.type) {
                case 'parent_component_selected':
                case 'parent_door_kit_type':
                    const exists = condValues.includes(selectedValue);
                    if (cond.op === 'is') return exists;
                    if (cond.op === 'not') return selectedValue !== "" && !exists;
                    if (cond.op === 'in') return selectedValue !== "";
                    break;
                default:
                    return true;
            }
            return false;
        });

        if (isMatch) {
            (scenario.actions || []).forEach(action => {
                const groupId = action.component;

                if (action.type === 'hide_accessory_components') {
                    const idsToHide = Array.isArray(action.value) ? action.value : [action.value];
                    idsToHide.forEach(id => {
                        if (id) rules.hiddenGroups.add(id);
                    });
                }
                else if (action.type === 'filter_accessory_component_options') {
                    if (!rules.hiddenProducts.has(groupId)) {
                        rules.hiddenProducts.set(groupId, new Set());
                    }

                    const hiddenSet = rules.hiddenProducts.get(groupId);
                    const targetPids = (action.product_ids || []).map(Number);

                    if (action.mode === 'include_products') {
                        targetPids.forEach(pid => hiddenSet.add(pid));
                    }
                    else if (action.mode === 'exclude_products') {
                        const groupData = accRoot.components.find(g => g.id === groupId);
                        if (groupData) {
                            groupData.products.forEach(p => {
                                if (!targetPids.includes(Number(p.id))) {
                                    hiddenSet.add(Number(p.id));
                                }
                            });
                        }
                    }
                }
            });
        }
    });
    return rules;
}
